<template>
  <div class="tab2 module_item">
    <div class="clearfix">
      <!-- <span class="search_title">CEIC</span> -->
      <el-button class="search_reset" type="text" @click="resetChecked">Reset</el-button>
    </div>
    <div class="tree_search">
      <!-- <el-input placeholder="Please enter the indicator" v-model="filterText"></el-input> -->
      <div class="tree_container">
        <el-tree
          ref="tree"
          show-checkbox
          node-key="name"
          :props="defaultProps"
          empty-text="No data was found"
          :load="loadNode"
          lazy
          @check-change="handleCheckChange"
          @check="checkNode"
          :render-content="renderContent"
        ></el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import { getMacroCommon } from "common/js/http/v2Api";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      filterText: "",
      defaultProps: {
        children: "children",
        label: "name",
        isLeaf: "leaf"
      }
    };
  },

  created() {},

  computed: {
    ...mapState({
      treeChecked(state) {
        return state.MacroChecked.treeChecked;
      }
    })
  },

  methods: {
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 注意:当 父节点只有当前一个子节点,选中该子节点  则也会选中父节点 所以要判断
    checkNode(data, status) {
      console.log("TCL: checkNode -> status", status);
      const checkedNodes = status.checkedNodes.filter(item => {
        if (typeof item.countryName != "undefined") {
          return item;
        }
      });
      // 关闭主页显示
      if (checkedNodes.length) {
        console.log("checkNode -> checkedNodes.length", checkedNodes.length)
        this.changeIndexShow(false);
      }
      this.setMacTreeChecked(checkedNodes);
    },

    handleCheckChange(data, checked, indeterminate) {
      // const checkeddata = this.$refs.tree.getCheckedNodes();
      // console.log("TCL: loadNode -> checkeddata", checkeddata);
      // @check-change 事件会触发当前所有子节点的checkchange,会造成大量的函数调用
      // 改为check事件  只调用当前点击节点的check事件,触发一次
    },

    async loadNode(node, resolve) {
      let params;
      let result;
      if (!node.data || node.data["leaf_node_flag"] != 1) {
        if (node.level === 0) {
          params = {
            api: "/api/queryFirstLvInfoByType.html",
            methodType: "GET",
            params: {
              type: "EN_CEIC"
            },
            userId: parseInt(this.Cookies.get("imsilkroad_userid")),
            userName: this.Cookies.get("imsilkroad_username")
            // userId: 3091,
            // userName: "imtest"
          };
        } else {
          params = {
            api: "/api/queryLvInfoByPID.html",
            methodType: "GET",
            params: {
              type: "EN_CEIC",
              lvNO: node.level,
              id: node.data.id,
              isNode: !Boolean(node.data["leaf_node_flag"])
            },
            userId: parseInt(this.Cookies.get("imsilkroad_userid")),
            userName: this.Cookies.get("imsilkroad_username")
            // userId: 3091,
            // userName: "imtest"
          };
        }
        let data = await getMacroCommon(params);
        result = data.result;
      } else {
        params = {
          api: "/api/queryIndictorBasicNameByLvID.html",
          methodType: "GET",
          params: {
            type: "EN_CEIC",
            lvID: node.data.id
          },
          userId: parseInt(this.Cookies.get("imsilkroad_userid")),
          userName: this.Cookies.get("imsilkroad_username")
          // userId: 3091,
          // userName: "imtest"
        };
        let data = await getMacroCommon(params);
        result = data.data.map(item => ({
          name: item.basics_name,
          countryName: item.country_cn_simplename,
          leaf: true,
          leaf_node_flag: 3, //指标最后一层 向下可以查具体指标,数据格式不一样, 自定义一个标记 3
          id: item.basics_name + new Date()
        }));
      }

      // result.forEach(item => {
      //   if (item["leaf_node_flag"] == 1) {
      //     item.leaf = true;
      //   }
      // });
      // console.log("TCL: loadNode -> result", result);
      return setTimeout(() => {
        resolve(result);
        this.setParentNode();
      }, 0); //模拟 懒加载 避免接口时长过快,看不到加载效果  造成直接全选
    },

    renderContent(h, { node, data, store }) {
      if (data["leaf_node_flag"] != 3) {
        return (
          <span class="custom-tree-node">
            <span class="isParentCls" title={node.label}>
              {node.label}
            </span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <span title={node.label}>{node.label}</span>
          </span>
        );
      }
    },

    //resove(node) 后 在下一个tick dom渲染完毕在获取dom元素
    setParentNode() {
      this.$nextTick(() => {
        const parenNode = document.getElementsByClassName("isParentCls");
        for (let item of parenNode) {
          const check = item.parentNode.previousElementSibling;
          if (check.getAttribute("class") == "el-checkbox") {
            check.style.display = "none";
          }
        }
      });
    },

    ...mapMutations(["setMacTreeChecked", "changeIndexShow"])
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    treeChecked(newValue) {
      //右侧删除时,手动去 设置新树的状态
      this.$refs.tree.setCheckedNodes(newValue);
    }
  }
};
</script>


<style scoped>
.search_title {
  float: left;
  font-size: 16px;
  color: #4e5671;
  line-height: 45px;
  font-weight: 600;
}
.search_reset {
  float: right;
  font-size: 16px;
  color: #0078ff !important;
  line-height: 45px;
  padding: 0px !important;
}
.tree_search >>> .el-input__inner {
  border-radius: 20px;
}
.tree_search >>> .el-input {
  margin-bottom: 20px;
}
.tree_search {
  height: 100%;
}
.tree_container {
  height: calc(100% - 250px);
  overflow: auto;
}
.tag_list {
  height: 200px;
  border: 1px solid #f3f4f5;
  padding: 10px;
  overflow: auto;
}
</style>